export default function SafetySection() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-[32px] md:text-[40px] font-heading text-foreground-950 mb-4">
            Your <span className="italic">Safety</span> Matters
          </h2>
          <p className="text-[13px] text-foreground-600 max-w-[480px] mx-auto leading-relaxed">
            We take transparency and user protection seriously. Here is what you should know about using the itaobuy spreadsheet.
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-left">
              <thead>
                <tr className="bg-secondary-100">
                  <th className="px-5 py-3.5 text-[12px] font-semibold text-foreground-950 rounded-l-xl">Risk Factor</th>
                  <th className="px-5 py-3.5 text-[12px] font-semibold text-foreground-700">Description</th>
                  <th className="px-5 py-3.5 text-[12px] font-semibold text-primary-700 rounded-r-xl">Our Approach</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-200">
                  <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Payment Processing</td>
                  <td className="px-5 py-3.5 text-[13px] text-foreground-600">We do not process payments</td>
                  <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">All transactions happen directly with sellers</td>
                </tr>
                <tr className="border-b border-background-200">
                  <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Data Privacy</td>
                  <td className="px-5 py-3.5 text-[13px] text-foreground-600">No personal data collection required</td>
                  <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">We only provide informational spreadsheet access</td>
                </tr>
                <tr className="border-b border-background-200">
                  <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Seller Verification</td>
                  <td className="px-5 py-3.5 text-[13px] text-foreground-600">External sellers are listed as-is</td>
                  <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">Buyers should independently verify sellers</td>
                </tr>
                <tr>
                  <td className="px-5 py-3.5 text-[13px] text-foreground-800 font-medium">Transparency</td>
                  <td className="px-5 py-3.5 text-[13px] text-foreground-600">Clear about service limitations</td>
                  <td className="px-5 py-3.5 text-[13px] text-primary-700 font-medium">Honest about what the spreadsheet does and does not do</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
            <div className="flex items-center gap-2 text-[12px] text-foreground-600">
              <span className="w-5 h-5 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-shield-check-line text-[10px] text-secondary-700"></i>
              </span>
              No payment data stored
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-foreground-300"></div>
            <div className="flex items-center gap-2 text-[12px] text-foreground-600">
              <span className="w-5 h-5 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-lock-line text-[10px] text-secondary-700"></i>
              </span>
              No account registration needed
            </div>
            <div className="hidden sm:block w-1 h-1 rounded-full bg-foreground-300"></div>
            <div className="flex items-center gap-2 text-[12px] text-foreground-600">
              <span className="w-5 h-5 rounded-full bg-secondary-100 flex items-center justify-center">
                <i className="ri-eye-line text-[10px] text-secondary-700"></i>
              </span>
              Transparent operations
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}